module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-2-thumb.5793f1de.png";